/**
 * Push Analytics events on GTM Datalayer
 * @param {String} category event category
 * @param {String} action event action
 * @param {String} label event label
 * @param {String} value event value
 * @param {Boolean} nonInteraction event type (false = not fired by user action)
 */
function trackGTMEvents(
  eventInfo = {},
  moreOptions = {},
  debug = false,
) {
  const defaultEIValues = {
    category: undefined,
    action: undefined,
    label: undefined,
    value: undefined,
    position: undefined,
    from: undefined,
    nonInteraction: false,
  };
  if (window) {
    if (debug) {
      console.log({
        event: 'GAEvent',
        eventInfo: {
          ...defaultEIValues,
          ...eventInfo,
        },
        ...moreOptions,
      });
    }
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'GAEvent',
      eventInfo: {
        ...defaultEIValues,
        ...eventInfo,
      },
      ...moreOptions,
    });
  }
}
export default trackGTMEvents;
